import { render, staticRenderFns } from "./OrderPaymentsProgressBar.vue?vue&type=template&id=c3324f54&scoped=true"
import script from "./OrderPaymentsProgressBar.vue?vue&type=script&lang=js"
export * from "./OrderPaymentsProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3324f54",
  null
  
)

export default component.exports